export default __webpack_public_path__ + "static/media/F0007.d5f941a8.png";